const path = '$workflow';

//
// ──────────────────────────────────────────────────────── I ──────────
//   :::::: W O R K F L O W : :  :   :    :     :        :          :
// ──────────────────────────────────────────────────────────────────
//

export const WORKFLOW_LIST = `${path}/workflow/list`;
export const WORKFLOW_CURRENT = `${path}/workflow/current`;
export const WORKFLOW_CURRENT_CLEAR = `${path}/workflow/current/clear`;
export const WORKFLOW_USERINFO = `${path}/workflow/userInfo`;
export const WORKFLOW_SEARCH = `${path}/workflow/search`;
export const WORKFLOW_FORM_ACTION = `${path}/workflow/set/form/action`;
export const WORKFLOW_DOCUMENT_PAGES = `${path}/workflow/documentpages/get`;

// 시스템/양식 옵션
export const GET_WORKFLOW_OPTIONS = `${path}/workflow/workflowoptions/get`;
export const ADMIN_APPOPTIONLIST_LOAD = `${path}/get/applicationoptionlist/load`;